import type { BlobActingAsFile } from "@models/ActionTypes";

export const railsActiveStorageDirectUploadsUrl = "/rails/active_storage/direct_uploads";

export function dataUrlToBlob(dataURL: string, sliceSize = 512): Blob {
  const contentType = dataURL.match(/data:(\w+\/\w+);/)?.[1];
  const base64Data = dataURL.replace(/data:[^,]+,/, "");
  const byteCharacters = atob(base64Data);
  const byteArrays: Uint8Array[] = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}

export function buildBlobForUpload(dataURL: string): BlobActingAsFile {
  const blob = dataUrlToBlob(dataURL);
  const typeParts = blob.type.match(/(\w+)\/(\w+)/);
  const type = typeParts?.[1];
  const subType = typeParts?.[2];
  (blob as BlobActingAsFile).name = `${type}.${subType}`;
  return blob as BlobActingAsFile;
}
